import { styled } from '@/styled-system/jsx';

export const StyledHeadingLink = styled('span', {
  base: {
    sm: {
      float: 'right',
    },
  },
});
